export var START_CHAT = "CONTACTS/START_CHAT";
export var LOAD_CONTACT_FROM_SERVER = "CONTACTS/LOAD_CONTACT_FROM_SERVER";
export var FAILED_TO_LOAD_CONTACTS = "CONTACTS/FAILED_TO_LOAD_CONTACTS";
export var OPEN_CONTACT = "CONTACTS/OPEN_CONTACT";
export var CLOSE_CONTACT = "CONTACTS/CLOSE_CONTACT";
export var SAVE_CONTACT_SCROLLTOP = "CONTACTS/SAVE_CONTACT_SCROLLTOP";